import { Shop as ShopType } from '@/types/summary'
import { Shop } from './Shop'
import { chunk } from '@/utils/format'

interface Props {
  shops: ShopType[]
}
export const ShopList: React.FC<Props> = ({ shops }) => {
  return (
    <div className="overflow-y-hidden px-[6px] sm:pt-[6px] pb-[2px] sm:mt-[15px] sm:bg-[#5381b4]">
      <div className="sm:mb-[10px] text-center text-black sm:text-white">
        本の購入はこちら
      </div>
      {!shops || shops.length == 0 ? (
        <div className="mb-[10px] text-center text-black sm:text-white">
          こちらの書籍は書店にて
          <br className="pc" />
          お買い求めください。
        </div>
      ) : (
        <>
          {chunk(shops, 5).map((ss, i) => (
            <div
              key={`shoplist-${i}`}
              className="flex flex-wrap gap-1 justify-center sm:justify-start mb-1"
            >
              {ss.map((s, i) => (
                <div key={i} className="min-w-[50px] hover:translate-y-[-6px]">
                  <Shop name={s.name} link={s.url} />
                </div>
              ))}
            </div>
          ))}
        </>
      )}
    </div>
  )
}
